// عجلة اقتباسات. كل اقتباس هنا موثّق (كتاب أو ملاحظات منشورة أو قائمة بريدية).
// لا تُضاف اقتباسات دون مصدر يمكن التحقق منه.
const ar = {
  items: [
    {
      text: "البرمجة ليست فيما تعرفه، بل فيما تستطيع اكتشافه بنفسك.",
      name: "Chris Pine",
      role: "مؤلّف كتاب 'Learn to Program'",
      image: "/img/quotes/idea_lamp.webp",
    },
    {
      text: "الطريقة الوحيدة لتعلّم لغة برمجة جديدة هي كتابة برامج بها.",
      name: "Brian Kernighan و Dennis Ritchie",
      role: "مؤلّفا كتاب 'The C Programming Language'",
      image: "/img/quotes/software.webp",
    },
    {
      text: "أي أحمق يستطيع كتابة شيفرة يفهمها الحاسوب. أما المبرمجون الجيّدون فيكتبون شيفرة يفهمها البشر.",
      name: "Martin Fowler",
      role: "مؤلّف كتاب 'Refactoring'",
      image: "/img/quotes/checking.webp",
    },
    {
      text: "الكلام سهل. أرني الشيفرة.",
      name: "Linus Torvalds",
      role: "مبتكر Linux",
      image: "/img/quotes/solving.webp",
    },
    {
      text: "يجب أن تُكتب البرامج ليقرأها البشر، وعرضًا فقط لتنفّذها الآلات.",
      name: "Harold Abelson",
      role: "مؤلّف مشارك لكتاب 'Structure and Interpretation of Computer Programs'",
      image: "/img/quotes/books.webp",
    },
    {
      text: "المحرّك التحليلي ينسج أنماطًا جبرية كما ينسج نول جاكار الزهور والأوراق.",
      name: "Ada Lovelace",
      role: "أول مبرمجة حاسوب في العالم",
      image: "/img/quotes/teaching.webp",
    },
    {
      text: "وظيفة البرمجيات الجيّدة أن تجعل المعقّد يبدو بسيطًا.",
      name: "Grady Booch",
      role: "أحد مبتكري UML",
      image: "/img/quotes/tools.webp",
    },
    {
      text: "البساطة شرط أساسي للموثوقية.",
      name: "Edsger W. Dijkstra",
      role: "حائز على جائزة تورينغ",
      image: "/img/quotes/idea_lamp.webp",
    },
  ],
};

export default ar;
